<template>
  <div>
    <h3 class="mb-3">Изменить флориста</h3>
    <form @submit.prevent="updateHandler">
      <div class="mb-3">
        <h2 class="required mb-2">Имя</h2>
        <va-input
          v-model.trim="$v.form.name.$model"
          class="mb-0"
          placeholder="Имя флориста"
        />
        <div
          v-if="!$v.form.name.required && $v.form.name.$error"
          class="error-message"
        >
          Обязательно для заполнения
        </div>
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Опыт</h2>
        <va-input
          v-model.trim="form.experience"
          class="mb-0"
          placeholder="Например: 5 лет"
        />
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Краткое описание</h2>
        <va-input
          v-model.trim="form.short_description"
          type="textarea"
          class="mb-0"
          :min-rows="2"
          :max-rows="3"
          placeholder="Краткое описание"
        />
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Описание</h2>
        <va-input
          v-model.trim="form.description"
          type="textarea"
          class="mb-0"
          :min-rows="4"
          :max-rows="8"
          placeholder="Полное описание"
        />
      </div>
      <div class="mb-3">
        <label for="file-upload" class="custom-file-upload">
          Загрузить фотографию
        </label>
        <input
          id="file-upload"
          ref="fileInput"
          type="file"
          class="file-input"
          accept="image/x-png,image/jpg,image/jpeg"
          @input="onFilePicked($event)"
        />
      </div>
      <div class="mb-3">
        <div v-if="florist.photo && !imageData">
          <img
            class="florist-photo"
            :src="florist.photo.url"
            alt="florist-photo"
          />
          <span>
            <va-button small @click.prevent="removeCurrentPhoto"
              >Удалить</va-button
            >
          </span>
        </div>
        <div v-if="imageData" class="uploaded-file">
          <img class="uploaded-file__img" :src="imageData" alt="img" />
          <span>
            <va-button small @click.prevent="removeImg">Удалить</va-button>
          </span>
        </div>
      </div>
      <div class="mt-3">
        <va-button color="danger" class="mr-1" @click.prevent="$emit('close')">
          Отменить
        </va-button>
        <va-button color="info" type="submit"> Сохранить </va-button>
      </div>
    </form>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapMutations } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  name: "FloristUpdate",
  props: {
    florist: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        name: this.florist.name || "",
        experience: this.florist.experience || "",
        short_description: this.florist.short_description || "",
        description: this.florist.description || "",
      },
      selectedFile: null,
      imageData: null,
      photoRemoved: false,
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
    },
  },
  methods: {
    ...mapMutations(["SET_GLOBAL_LOADER"]),
    async updateHandler() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      } else {
        this.SET_GLOBAL_LOADER(true);
        try {
          let photoId = this.florist.photo_id;

          if (this.photoRemoved) {
            photoId = null;
          } else if (this.selectedFile) {
            const formData = new FormData();
            formData.append("file", this.selectedFile, this.selectedFile.name);
            const res = await api.post("/upload-file", formData);
            photoId = res.data.id;
          }

          const data = {
            name: this.form.name,
            experience: this.form.experience || null,
            short_description: this.form.short_description || null,
            description: this.form.description || null,
            photo_id: photoId,
          };

          await api.put(`/admin/florists/${this.florist.id}`, data);
          this.$emit("updated");
          this.SET_GLOBAL_LOADER(false);
        } catch (error) {
          console.error("Ошибка обновления флориста:", error);
          this.SET_GLOBAL_LOADER(false);
          alert("Ошибка при обновлении флориста");
        }
      }
    },
    onFilePicked(event) {
      if (this.florist.photo && !this.photoRemoved) {
        alert("Чтобы изменить фото, сначала удалите текущее");
        this.$refs.fileInput.value = "";
        return;
      }
      this.selectedFile = event.target.files[0];
      const file = event.target.files;
      if (file && file[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(file[0]);
      }
    },
    removeImg() {
      this.imageData = null;
      this.selectedFile = null;
      this.$refs.fileInput.value = "";
    },
    removeCurrentPhoto() {
      this.photoRemoved = true;
      this.florist.photo = null;
    },
  },
};
</script>

<style>
.uploaded-file {
  display: flex;
  align-items: center;
  gap: 10px;
}
.uploaded-file__img {
  width: 150px;
  height: auto;
  border-radius: 8px;
}
.florist-photo {
  width: 150px;
  height: auto;
  border-radius: 8px;
}
</style>
